import {Logic} from './Type'
import {IndexState} from './Index'
import {LoginState} from './Login'
import {SearchState} from './Search'
import {ModalState} from './Modal'

export class Main extends Logic.Type {
    
    static Instance = new Main(new class {

        Update(state: Main): void {
            Main.Instance = state
        }
    })
    // default_language: number
    Location: string
    LoginState = Logic.Type.Add(this, new LoginState)
    IndexState = Logic.Type.Add(this, new IndexState)
    SearchState = Logic.Type.Add(this, new SearchState)
    ModalState = Logic.Type.Add(this, new ModalState)
}


// WEBPACK FOOTER //
// ./src/Logic/Main.ts